import { render, staticRenderFns } from "./BotoesAcoes.vue?vue&type=template&id=0431a5b0&scoped=true"
import script from "./BotoesAcoes.vue?vue&type=script&lang=js"
export * from "./BotoesAcoes.vue?vue&type=script&lang=js"
import style0 from "./BotoesAcoes.vue?vue&type=style&index=0&id=0431a5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0431a5b0",
  null
  
)

export default component.exports